<template>
    <div>
        <div class="info">
            <div class="content">
                <div class="top">
                    <div>{{userInfo.realName}}</div>
                    <div>{{userInfo.userId}}</div>
                </div>
                <div>{{userInfo.companyName}}</div>
            </div>
        </div>
        <div class="jixiao">
            <div class="content">
                <div class="key">本月绩效</div>
                <div class="value">{{userInfo.monthUserMoney}}</div>
            </div>
            <div class="line"></div>
            <div class="content">
                <div class="key">本周绩效</div>
                <div class="value">{{userInfo.money}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "userInfo",
        data() {
            return {
                userInfo: {}
            }
        }, created() {
            this.getUserInfo();
        }, methods: {
            getUserInfo() {
                this.$get('/app/v1/tcHelp/myPage')
                    .then(res => {
                        if (res.code == 200) {
                            this.userInfo = res.data;
                        } else {
                            this.util.toast({msg: res.message})
                        }
                    })
                    .catch(error => {
                    });
            }
        }
    }
</script>

<style scoped>
    * {
        font-family: PingFangSC-Regular, PingFang SC;
    }

    .info {
        width: 95%;
        margin: 0.1rem auto;
        background: url("../../assets/img/tcHelp/userInfo_bg.png");
        background-size: cover;
    }

    .info .content {
        padding: 0.2rem 0.2rem;
        font-size: 0.26rem;
        font-weight: 400;
        color: #FFFFFF;
    }

    .info .content .top{
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.2rem;
    }

    .jixiao {
        margin: 0.1rem auto;
        width: 95%;
        height: 150px;
        background: #F9FBFE;
        border-radius: 4px;
    }
    .jixiao .content{
        display: flex;
        justify-content:space-between;
        height: 48%;
        padding: 0rem 0.4rem;
        line-height: 0.75rem;
    }

    .jixiao .key {
        font-size: 0.14rem;
        font-weight: 400;
        color: #999999;
    }

    .jixiao .value {
        font-size: 0.2rem;
        font-weight: 600;
        color: #333333;
    }

    .line {
        width: 100%;
        height: 1px;
        border: 1px solid #D8D8D8;
    }

</style>
